<script setup>
import Event from '@/components/Event.vue'
import { strapiQuery } from '@/composables/strapiQuery'

const { data: events, loading, error } = strapiQuery('api/events?populate=image&sort=time:desc')
</script>

<template>
  <v-card class="mx-auto" max-width="600" border>
    <v-progress-linear v-if="loading" indeterminate color="primary" />
    <v-alert v-else-if="error" type="error" class="ma-4">
      Fehler beim Laden der Veranstaltungen. Bitte überprüfen Sie die Verbindung zum CMS.
    </v-alert>
    <v-container v-else fluid>
      <Event
        v-for="event in events"
        :name="event.name"
        :description="event.description"
        :img-url="event.image.url"
        :key="event.id"
      />
    </v-container>
  </v-card>
</template>
